module.exports = __webpack_public_path__ + "img/p66-yearbooks-2015-2017.2583ea92.jpg";